import React, { useEffect } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import Button from 'components/Button';
import Spinner from 'components/Spinner/desktop';
import Modal from 'components/ModalProvider/Modal/Modal';
import SVG from 'components/SVG';

import useModalChangePassword from 'features/Auth/model/useModalChangePassword';

import ShieldSVG from 'shared/img/shield.svg'

import './ModalChangePassword.scss';

const b = block('modal-change-password-desktop');

const ModalChangePassword = () => {
  const model = useModalChangePassword();

  const locale = useSelector(state => state.locale.locale);
  const changePasswordLoading = useSelector(state => state.users.actionProcessing);

  return (
    model.forShow ?
      <Modal
        isPermanent
        content={
          <article className={b()}>
            <Spinner isLoading={changePasswordLoading} />
            <h3 className={b('title')}>{locale.changePasswordFirsLog}</h3>
            <div onClick={model.onGeneratePassword} className={b('secure-password')}>
              <div>
                {locale.securePassword}
              </div>
              <SVG svgProps={{ svg: ShieldSVG }} className={b('shield')} />
            </div>
            <form className={b('form')} onSubmit={model.handleFormSubmit}>
              <div className={b('inputs')}>
                <label className={b('item')}>
                  <p className={b('item-title')}>{`${locale.newPassword}`}</p>
                  <div className={b('item-field')}>
                    <Input
                      value={model.state.newPassword}
                      color="password"
                      name="password"
                      type="password"
                      onChange={e => model.handleChangeState('newPassword', e.currentTarget.value)}
                      placeholder={locale.newPassword}
                      autoComplete="new-password"
                      withEye
                    />
                  </div>
                </label>

                <label className={b('item')}>
                  <p className={b('item-title')}>{`${locale.confirmNewPassword}`}</p>
                  <div className={b('item-field')}>
                    <Input
                      value={model.state.repeatNewPassword}
                      name="repeatNewPassword"
                      color="password"
                      type="password"
                      onChange={e => model.handleChangeState('repeatNewPassword', e.currentTarget.value)}
                      placeholder={locale.confirmNewPassword}
                      autoComplete="new-password"
                      withEye
                    />
                  </div>
                </label>
              </div>
              <div className={b('button')}>
                <Button disabled={model.disabled || changePasswordLoading} type="submit">
                  <span className={b('button-text')}>{locale.change}</span>
                </Button>
              </div>
            </form>
          </article>
        }
      />
      : null
  );
};

export default ModalChangePassword;
